import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

$.fn.FixedContent = function() {
  let self = this
  self.scroll_trigger = null
  self.wrapper = self.closest('.fixed-content-wrapper')

  self.initDesktopAnimations = function() {
    if (window.innerWidth > 767) {
      gsap.set(self, {
        transformOrigin: "center center",
        backfaceVisibility: "hidden",
        willChange: "transform"
      });
      const animation = gsap.to(self, {
        scrollTrigger: {
          trigger: self.wrapper,
          start: `top-=${document.querySelector(".header").offsetHeight + 30}px top`,
          end: () => `bottom-=${self[0].offsetHeight + document.querySelector(".header").offsetHeight + 30}px top`,
          pin: true,
          pinSpacing: false,
          scrub: true,
          anticipatePin: 0,
          onStart: () => {
            gsap.set(self, {
              force3D: true,
              z: 0.01
            });
          },
          onComplete: () => {
            gsap.set(self, {
              clearProps: "transform,z",
              willChange: "auto"
            });
          }
        },
        ease: "none",
        force3D: true,
        z: 0.01
      })
      self.scroll_trigger = animation.scrollTrigger
    }
  }

  window.addEventListener("resize", () => {
    console.log(self.scroll_trigger)
    if (self.scroll_trigger) {
      self.scroll_trigger.kill()
      self.scroll_trigger = null
    }
    self.initDesktopAnimations()
  })

  return function() {
    self.initDesktopAnimations()
    return self
  }()
}
